import { use } from 'react'

import { FormGridContext } from '../../contexts'

export const useFormGridContext = () => {
  return use(FormGridContext)
}
